module.exports = "<div class=\"footer {{ mode }}\">\n  <button mat-button\n    (click)=\"showTermsAndConditions()\">\n    Terms and Conditions\n  </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/footer.component.html
// module id = ./src/app/layouts/footer.component.html
// module chunks = main